import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Header from "./components/Layout/Header";
import Hero from "./components/Sections/Hero";
import About from "./components/Sections/About";
import Experience from "./components/Sections/Experience";
import Projects from "./components/Sections/Projects";
import Gallery from "./components/Sections/Gallery";
import Contact from "./components/Sections/Contact";
import data from "./data.json";
import "./App.css";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    // Initialize from localStorage immediately
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme) {
      return savedTheme === "dark";
    }
    return window.matchMedia("(prefers-color-scheme: dark)").matches;
  });
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Apply theme immediately on mount
    document.documentElement.className = darkMode ? "dark" : "light";

    // Simulate loading
    setTimeout(() => setIsLoading(false), 1000);
  }, [darkMode]);

  useEffect(() => {
    // Apply theme to document whenever darkMode changes
    document.documentElement.className = darkMode ? "dark" : "light";
    localStorage.setItem("theme", darkMode ? "dark" : "light");
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
  };

  const toggleMenu = (state) => {
    setIsMenuOpen(state);
  };

  if (isLoading) {
    return (
      <div className="loading-screen">
        <motion.div
          className="loading-content"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div
            className="loading-spinner"
            animate={{ rotate: 360 }}
            transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
          />
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          ></motion.h2>
        </motion.div>
      </div>
    );
  }

  return (
    <div className="App">
      <Header
        darkMode={darkMode}
        toggleDarkMode={toggleDarkMode}
        isMenuOpen={isMenuOpen}
        toggleMenu={toggleMenu}
      />

      <main>
        <Hero data={data} />
        <About data={data} />
        <Experience data={data} />
        <Projects data={data} />
        <Gallery data={data} />
        <Contact />
      </main>

      <footer className="footer">
        <div className="container">
          <motion.div
            className="footer-content"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <p>&copy; 2025 Shreyas Shrawage. All rights reserved.</p>
            <p>Built with React & Framer Motion</p>
          </motion.div>
        </div>
      </footer>
    </div>
  );
}

export default App;
